<template>
    <div class="tabs bg_fff">
        <el-row>
            <el-col :span="6" v-for="(tab,index) in list" :key="index" class="flex aic jcc pt20 pb20">
                <div class="item flex jcc aic">
                    <div class="icon flex0 mr10">
                        <img :src="tab.icon" alt="">
                    </div>
                    <div class="text flex0">
                        <h3 class="mb10">{{tab.name}}</h3>
                        <el-badge :value="tab.msg">
                            <div class="fs16">待处理</div>
                        </el-badge>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
  export default {
    name: 'home-tabs',
    data() {
      return {
        list: [
          {name: '远程门诊', msg: '3', icon: require('../../assets/icon/index/远程会诊.png')},
          {name: '远程会诊', icon: require('../../assets/icon/index/远程转诊.png')},
          {name: '网络诊间', icon: require('../../assets/icon/index/图文咨询.png')},
          {name: '慢病续方', icon: require('../../assets/icon/index/远程诊断.png')},
        ]
      };
    },
    computed: {},
    components: {},
    mixins: [],
    created() {

    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {}
  };
</script>

<style scoped lang="scss">
    span {
        font-size: 60px;
    }

    .item {
        width: 250px;
        height: 100px;
        background: #FFFFFF;
        box-shadow: 0 2px 10px 0 rgba(54, 146, 249, 0.10);
        border-radius: 2px;
    }

    .red {
        color: red;
    }

    .green {
        color: green;
    }

    .blue {
        color: blue;
    }

    .orange {
        color: orange;
    }
</style>
